import Http from "../../http/client";
import {RequestQueryBuilder} from "@nestjsx/crud-request";

export default async (userId, vehicleId) => {
  const qb = RequestQueryBuilder.create();
  qb.setJoin({field: 'users', select: ['id']});

  const vehicle = await Http.get('admin/vehicles/'+vehicleId, {
    params: qb.queryObject
  });

  vehicle.data.users.push({id: userId});

  const response = await Http.patch('admin/vehicles/'+vehicleId, {
    users: vehicle.data.users
  });
  return response.data;
}
